let keyStoreType = [
  'INTERNAL',
  'PKCS11',
  'MPCM'
]

export default keyStoreType
